import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

function Text({
  tag: TextTag,
  weight,
  muted,
  tall,
  monospaced,
  underlined,
  leftAligned,
  centered,
  rightAligned,
  styles: customStyles,
  children,
  ...props
}) {
  return (
    <TextTag
      className={classnames(
        styles.text,
        { [styles.medium]: weight === 'medium' },
        { [styles.bold]: weight === 'bold' },
        { [styles.muted]: muted },
        { [styles.tall]: tall },
        { [styles.monospaced]: monospaced },
        { [styles.underlined]: underlined },
        // { [styles.leftAligned]: leftAligned },
        { [styles.centered]: centered },
        { [styles.rightAligned]: rightAligned },
        ...customStyles
      )}
      {...props}>
      {children}
    </TextTag>
  );
}

Text.propTypes = {
  tag: PropTypes.string,
  muted: PropTypes.bool,
  weight: PropTypes.oneOf(['regular', 'medium', 'bold']),
  tall: PropTypes.bool,
  monospaced: PropTypes.bool,
  underlined: PropTypes.bool,
  leftAligned: PropTypes.bool,
  centered: PropTypes.bool,
  rightAligned: PropTypes.bool,
  styles: PropTypes.array,
  children: PropTypes.any
};

Text.defaultProps = {
  tag: 'span',
  muted: false,
  weight: 'regular',
  tall: false,
  monospaced: false,
  underlined: false,
  leftAligned: true,
  centered: false,
  rightAligned: false,
  styles: [],
  children: null
};

export default Text;
